module.exports = __webpack_public_path__ + "img/neutral.e7c3cf6b.png";